import React from 'react';
import { useFetchOnPageSeoTestDetailsQuery } from '../service';
import { Alert, Icon, Spin, Card } from 'antd';
import FailedCheckTitle from './FailedCheckTitle';
import FailedCheckDescription from './FailedCheckDescription';
import '../FailedChecks.less';


type Props = {
    seoTestKey: string;
};


export default function FailedCheckDetails({ seoTestKey }: Props) {
    const { data: seoTestDetails, isFetching, isError } = useFetchOnPageSeoTestDetailsQuery({ seo_test_key: seoTestKey });

    return (
        <Card className="failed-seo-test" title={seoTestDetails ? <FailedCheckTitle seoTestDetails={seoTestDetails} /> : null}>
            {isFetching && <Spin className="loader" indicator={<Icon type="loading" spin />} />}
            {!isFetching && isError && <Alert message="Unknown test type" type="error" showIcon />}
            {!isFetching && seoTestDetails && <FailedCheckDescription seoTestDetails={seoTestDetails} />}
        </Card>
    );
}
